module.exports = __webpack_public_path__ + "static/media/ultifit_at_home.2aafa9ee.jpg";